import * as vp from 'vopay';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './FAQCategoriesDropdownList.module.scss';
import dropdownArrow from '../../../assets/images/faq_dropdownArrow.svg';
import usePostFAQUpdateClickCount from '../../hooks/useApi/usePostFAQUpdateClickCount';

const { SubTitle } = vp;

type FAQCategoriesDropdownListProps = {
  ID: string;
  title: string;
  description: string;
  dataLoaded: boolean;
  hasBeenOpened: boolean;
};

const FAQCategoriesDropdownList: React.FC<FAQCategoriesDropdownListProps> = ({
  ID,
  title,
  description,
  dataLoaded,
  hasBeenOpened,
}) => {
  const [isDropdownListOpen, setIsDropdownListOpen] = useState(false);
  const location: { pathname: string; state: {} } = useLocation();
  const { selectedQuestion } = (location?.state as { category: string; selectedQuestion: string }) || {};
  const [highlightEnabled, setHighlightEnabled] = useState(false);
  const [, postFAQUpdateClickCount] = usePostFAQUpdateClickCount({});

  const renderTextWithLinks = (text: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        if (part.charAt(part.length - 1) === '.') {
          return (
            <>
              <a
                key={index}
                href={part.slice(0, -1)}
                style={{ color: '#3B339E' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {part.slice(0, -1)}
              </a>
              .
            </>
          );
        }
        return (
          <a key={index} href={part} style={{ color: '#3B339E' }} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  useEffect(() => {
    if (selectedQuestion === undefined) {
      setIsDropdownListOpen(false);
      setHighlightEnabled(false);
    } else if (selectedQuestion === title && !hasBeenOpened) {
      setIsDropdownListOpen(true);
      if (dataLoaded) {
        setHighlightEnabled(true);
        const timeoutId = setTimeout(() => {
          setHighlightEnabled(false);
          setIsDropdownListOpen(false);
        }, 4000);
        return () => {
          clearTimeout(timeoutId);
        };
      }
    }
    return () => {};
  }, [selectedQuestion, dataLoaded]);

  useEffect(() => {
    if (isDropdownListOpen) {
      postFAQUpdateClickCount({ QuestionID: ID });
    }
  }, [isDropdownListOpen]);

  const toggleDropdownList = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    setIsDropdownListOpen(!isDropdownListOpen);
  };
  return (
    <div className={styles.dropDownItem} onClick={toggleDropdownList}>
      <div
        className={styles.dropDownTitleContainer}
        style={
          highlightEnabled
            ? { backgroundColor: '#FFE391', padding: '4px 8px', borderRadius: '7px' }
            : { backgroundColor: 'unset', padding: 'unset', borderRadius: 'unset' }
        }
      >
        <SubTitle subTitle={title} fontSize="16px" />
        <img
          src={dropdownArrow}
          alt=""
          style={isDropdownListOpen ? { transform: 'rotate(180deg)' } : { transform: 'unset' }}
        />
      </div>
      {isDropdownListOpen ? <p className={styles.dropDownDescription}>{renderTextWithLinks(description)}</p> : null}
    </div>
  );
};

export default FAQCategoriesDropdownList;
